export default "__VITE_ASSET__DzT2STgj__"